import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav";
import Hero from "./Hero";
import ServicesSection from "./ServicesSection";
import ProductsSection from "./ProductsSection";
import ProcessSection from "./ProcessSection";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

function MainApp() {
  const location = useLocation();

  /* support /#services deep links arriving from other routes */
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        requestAnimationFrame(() =>
          el.scrollIntoView({ behavior: "smooth" })
        );
      }
    }
  }, [location.hash]);

  return (
    <div className="App">
      <title>EffiGen LLC — Expert AI Services | Custom AI Products &amp; Consulting</title>
      <meta
        name="description"
        content="EffiGen LLC builds custom AI products for engineering fields and provides expert AI consulting and training. Book a free consultation today."
      />
      <link rel="canonical" href="https://effigen.ai/" />
      <Nav />
      <main>
        <Hero />
        <ServicesSection />
        <ProductsSection />
        <ProcessSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default MainApp;
